import { defineComponent as _defineComponent } from 'vue';
import { computed, unref } from "vue";
import { deletePage } from "./services";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/stores/userStore";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PageDropdown',
    props: {
        page: null,
        published: null
    },
    emits: ["onRemove", "onSuccess", "onError"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCaretDown);
        const { isAnonymous } = storeToRefs(useUserStore());
        const readOnly = computed(() => props.page.shared || props.published || unref(isAnonymous));
        function onDelete(page_id) {
            deletePage(page_id)
                .then((response) => {
                emit("onRemove", page_id);
                emit("onSuccess");
            })
                .catch((error) => {
                emit("onError", error);
            });
        }
        return { __sfc: true, props, isAnonymous, emit, readOnly, onDelete, FontAwesomeIcon };
    }
});
